export function getVariant(name, number) {
  return `${name} ${number}`;
}
